import { EppoJSClient } from '@eppo/js-client-sdk';

import { createContext } from 'react';

export const EppoContext = createContext<EppoJSClient | undefined>(undefined);
